import Ripples from '../../assets/images/Ripples.svg?react';

export const FullPageLoader = () => {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
            <div style={{width: '100px', height: '100px'}}>
                <Ripples style={{width: '100%', height: '100%'}} />
            </div>
        </div>
    );
}